import { Injectable } from '@angular/core';
import {BehaviorSubject,} from "rxjs";
import {HttpClient} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class ServicesService {
  constructor(private httpClient: HttpClient) {}
  private elNumber: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  getActiveService(): number {
    return this.elNumber.value;
  }

  setActiveService(value: number): void {
    this.elNumber.next(value);
  }

  getActiveServiceObservable() {
    return this.elNumber.asObservable();
  }

}
